'use strict';

(function ($) {

    function showFormAlertMessage($form, type) {
        let $submit = $('[type="submit"]', $form);

        let banner_height = 0;
        if ($('.banner.fixed-top') || $('body.with-navbar-fixed')) {
            banner_height = $('.banner').outerHeight();
        }

        let scrollDuration = 400;
        let $alert = $('.alert-form-' + type, $form);
        let $scrollTo = false;

        console.log('showFormAlertMessage type', type);
        console.log('showFormAlertMessage', $alert);

        if (type === 'success' || type === 'error') {
            $scrollTo = $('.form-alerts', $form);
        } else if (type === 'error_no_order_items') {
            $scrollTo = $('.card-order-summary');
            $alert = $('.alert-form-error_no_order_items');
            alert($alert.text().trim());
        }

        $alert.show();

        if ($scrollTo.length) {
            $('html, body').animate({
                scrollTop: ($scrollTo.offset().top - banner_height - 30),
                duration: scrollDuration,
            });
        }

        $submit
            .removeAttr('disabled')
            .css('width', 'auto')
            .html($submit.data('original-text'));

    }

    $('body')
        .on('submit', '#contact-form', function (e) {
            e.preventDefault();
            const $form = $(this);
            const $submit = $('[type="submit"]', $form);

            $submit
                .attr('disabled', true)
                .data('original-text', $submit.html())
                .css('width', $submit.outerWidth())
                .html('<i class="fa-solid fa-spinner-scale fa-spin-pulse"></i>');

            $('.form-alerts > .alert').hide();

            let formData = new FormData($form[0]);
            formData.append('action', 'submit_ajax_contact_form');
            formData.append('nonce', jsData.nonce);
            formData.append('page_id', jsData.currentId);

            if (!formData.has('rgpd')) {
                formData.set('rgpd', 0);
            }

            $.ajax({
                method: 'post',
                url: jsData.ajaxUrl,
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {

                    if (response.success) {

                        $('.is-invalid', $form).removeClass('is-invalid');

                        // Si tout est OK, on va rediriger le formulaire vers une page de remerciement
                        if (response.validation_success) {
                            if (response.email_success) {
                                if (response.redirect_url) {
                                    if (window.location.href == response.redirect_url) {
                                        window.location.reload();
                                    } else {
                                        window.location.href = response.redirect_url;
                                    }
                                } else {
                                    showFormAlertMessage($form, 'success');
                                }
                            } else {
                                showFormAlertMessage($form, 'error-send-email');
                            }
                        } else {

                            // J'ajoute tous les .is-invalid et j'ajoute les messages d'erreur
                            $.each(response.validation_errors, function (key, value) {
                                let $input = $('[name="' + key + '"]', $form);
                                let $form_group = $input.parents('.form-group');
                                let $input_validation = $form_group.find(' > *').eq(0);

                                if (key === 'order_items') {
                                    showFormAlertMessage($form, 'error_no_order_items');
                                } else if ($form_group.length) {
                                    $input.addClass('is-invalid').removeClass('is-valid');
                                    $input_validation.addClass('is-invalid').removeClass('is-valid');
                                    $('.invalid-feedback', $form_group).html(value);
                                }
                            });

                            // Je définis en .is-valid tout ce qui n'est pas retourné comme une erreur
                            $.each(Array.from(formData.entries()), function () {
                                const key = this[0];
                                const $input = $('[name="' + key + '"]', $form);

                                if ($input.is(':visible') && typeof response.validation_errors[key] === 'undefined') {
                                    $input.addClass('is-valid').removeClass('is-invalid');
                                }
                            });

                            // Je focus le premier champ invalide
                            let $first_invalid = $('.is-invalid', $form).eq(0);

                            console.log('$first_invalid', $first_invalid);

                            if ($first_invalid.length) {
                                // Si le first_invalid n'est pas focusable, on va chercher le premier champ dedans
                                // Utile pour les groupes de checkboxes & radios qui sont dans un div.row
                                if (!/input|select|textarea|button|object/.test($first_invalid.prop("nodeName").toLowerCase())) {
                                    $first_invalid = $('input, select, textarea, button, object', $first_invalid).first();
                                }

                                $first_invalid.focus();
                            }

                            showFormAlertMessage($form, 'error_validation');
                        }

                    } else {
                        showFormAlertMessage($form, 'error');
                    }

                },
                error: function () {
                    showFormAlertMessage($form, 'error');
                }
            });

            return false;
        })
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/form-contact.js